import { API } from 'aws-amplify';
import { v1 as uuidv1 } from 'uuid';

const putFile = (FILE_UPLOAD_URL, file) => {
    return new Promise(function (resolve, reject) {

    const xhr = new XMLHttpRequest();
      xhr.open('PUT', FILE_UPLOAD_URL);
      xhr.setRequestHeader('Content-Type', file.type);
      xhr.onload = () => {
        if (xhr.status !== 200) {
          reject({
              status: this.status,
              statusText: xhr.statusText
          });
        } else {
          let fileURL = FILE_UPLOAD_URL.split('?')[0];
          // console.log('final img url :', fileURL);
          resolve(fileURL);
        }
      };
      xhr.onerror = function () {
          reject({
              status: this.status,
              statusText: xhr.statusText
          });
      };
      xhr.send(file);

    });
  };
  
  
  const UploadFile = async (url, path, file, asset) => {

    let FILE_UPLOAD_URL ='';
    let filename = '';   

    // if (folder === 'assets'){
    //   filename = 'assets/' + site_ref + '/' + file.name.replace(/ /g, "_");
    // }else{
      // rename img files uuid    
    const name = file.name.split('.') 
    filename = asset + "_" + uuidv1() + '.' + name[1]
    // }

    await API.post(url, path, {
        body: {
            name: filename,
            type: file.type, 
          },
        headers: {
            'x-api-key': process.env.REACT_APP_API_KEY,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
    }).then(response => {
        // console.log(response)
        FILE_UPLOAD_URL = response.uploadURL;
    }).catch(error => {
        console.log(error)
    });  

    if (FILE_UPLOAD_URL){
        const fileURL = await putFile(FILE_UPLOAD_URL, file);
        return fileURL;
    }else{
        return false;
    }
  };
  
  export default UploadFile;